var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96738 3.05156C4.02625 2.99269 4.05569 2.96325 4.08162 2.93942C4.71925 2.35353 5.69934 2.35353 6.33697 2.93942C6.3629 2.96325 6.39234 2.99269 6.45121 3.05156L7.66637 4.26672C8.33475 4.9351 8.52591 5.94446 8.14821 6.81095C7.77051 7.67744 7.96166 8.6868 8.63004 9.35518L10.6274 11.3525C11.2958 12.0209 12.3051 12.2121 13.1716 11.8344C14.0381 11.4567 15.0475 11.6478 15.7158 12.3162L16.931 13.5314C16.9899 13.5902 17.0193 13.6197 17.0431 13.6456C17.629 14.2832 17.629 15.2633 17.0431 15.9009C17.0193 15.9269 16.9899 15.9563 16.931 16.0152L16.1924 16.7538C15.5909 17.3553 14.7238 17.6078 13.8934 17.4233C8.2354 16.1659 3.81662 11.7472 2.55929 6.08917C2.37476 5.25878 2.62726 4.39167 3.22876 3.79018L3.96738 3.05156Z",
    stroke: "url(#paint0_linear_1_125)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_125",
    x1: 2.5,
    y1: 9.99128,
    x2: 17.4826,
    y2: 9.99128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.eb1cfb5afdec6b02bb04b1846095c2fb.svg";
export { ForwardRef as ReactComponent };